import { ArrowForwardIosRounded, Check, ErrorOutline } from "@mui/icons-material";
import { TableCell, TableRow, Tooltip } from "@mui/material";
import { ITableColumn } from "App/Typings/Table";
import { useHistory } from "react-router-dom";

const classes = {
  rowCell: {
    cursor: "pointer !important",
    backgroundColor: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
    textAlign: "right",
  },
  itemIcon: {
    cursor: "grab",
  },
  tableCell: {
    color: "primary.copy",
  },
};

interface IAttributeFeatureTableCellProps {
  element: any;
  columns: ITableColumn[];
}

export default function AttributeFeatureTableCell({ element, columns }: IAttributeFeatureTableCellProps) {
  var history = useHistory();

  function displayIsActive() {
    if (element["feature"].isActive) {
      return <Check sx={{ ml: "5%", color: "primary.main" }} />;
    } else {
      return <ErrorOutline sx={{ ml: "5%", color: "secondary.main" }} />;
    }
  }

  return (
    <>
      <TableRow
        hover
        key={element.id}
        sx={classes.rowCell}
        onClick={() => history.push(`/abac/${element.appId}/feature/${element["feature"].id}`)}
      >
        {columns.map((column: ITableColumn, elementIndex: number) => {
          return (
            <Tooltip key={`${element.id}-${elementIndex}`} title={"Manage " + element["feature"].name}>
              <TableCell align="left" sx={classes.tableCell}>
                {column.label === "Is Active" ? (
                  displayIsActive()
                ) : column.label === "" ? (
                  <ArrowForwardIosRounded sx={{ ml: "80%" }} />
                ) : (
                  element["feature"].name
                )}
              </TableCell>
            </Tooltip>
          );
        })}
      </TableRow>
    </>
  );
}
